import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap, CheckCircle, Tag } from 'lucide-react';

const PILLS = [
  { icon: Shield, text: 'Consulta segura y cifrada' },
  { icon: Zap, text: 'Respuesta en minutos' },
  { icon: CheckCircle, text: 'Fuentes oficiales verificadas' },
];

export default function HeroSection() {
  return (
    // #07 — Reduced vertical padding on mobile (py-8 sm:py-16)
    <section className="hero-gradient py-8 sm:py-16 px-4 text-center">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="max-w-3xl mx-auto"
      >
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-white font-bold leading-tight mb-4"
          style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 'clamp(1.75rem, 5vw, 3.5rem)' }}
        >
          Conoce los bienes de cualquier persona en Colombia
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-white/80 text-base sm:text-lg mb-6 max-w-xl mx-auto leading-relaxed"
        >
          Encontramos los vehículos y propiedades que estén a nombre de la persona consultada.
          Recibe el informe en minutos.
        </motion.p>

        {/* #01 — Price pill visible from first screen */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.25 }}
          className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/30 text-white font-bold px-5 py-2.5 rounded-full mb-6 text-base"
          data-testid="price-pill"
        >
          <Tag size={16} className="text-[#10B981]" />
          Informe completo — $99.000 COP
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="flex flex-wrap justify-center gap-3"
        >
          {PILLS.map(({ icon: Icon, text }, i) => (
            <motion.div
              key={text}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.4 + i * 0.1 }}
              className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-sm font-medium px-4 py-2 rounded-full"
            >
              <Icon size={15} className="text-[#10B981]" />
              {text}
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
}
